import React, { useState } from "react";
import { UserGames } from "../Context/UserGames";
import { Table, Button, Input} from 'antd';
import { useContext, useEffect } from "react";
import axios from "axios";

const DataGames = () => {

    const {functions, dataGame, setDataGame, fetchStatus, setFetchStatus}= useContext (UserGames)
    
    const {getGame, handleEdit, handleDelete} = functions

        
    useEffect (() => {
    
    
        if (fetchStatus) {
        getGame()
        setFetchStatus(false)}},[getGame, fetchStatus, setFetchStatus]
        
    )


    const columns = [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
         
        },
        
        {
          title: 'Preview',
          dataIndex: 'image_url',
          key: 'image_url',
          render: (e, index) => { return (
          
            <img src={e} alt="games" width={75} height={75} />
          )
          },
         
        }, 

        {
          title: 'Genre',
          dataIndex: 'genre',
          key: 'genre',
         
        },
        {
          title: ' Single Player',
          dataIndex: 'singlePlayer',
          key: 'singlePlayer',
          render : (result) => {return result === 1 ? 'Yes' : 'No'},
        
        },
          {
            title: ' Multi Player',
            dataIndex: 'multiplayer',
            key: 'multiplayer',
            render : (result) => {return result === 1 ? 'Yes' : 'No'},
            
            },
          
          {
            title: 'Platform',
            dataIndex: 'platform',
            key: 'platform',
            
          },
          {
            title: 'Release',
            dataIndex: 'release',
            key: 'release',
           
          },

        {
          title: 'Action',
          key: 'action',
          render: (res, index) => (
            <>
            <Button type="primary" style={{backgroundColor:"blueviolet"}} value={res.id} onClick={handleEdit} style={{marginLeft:"10px"}} >Edit</Button>
            <br/>
            <br/>
            <Button type="primary" danger value={res.id} onClick={handleDelete} style={{marginLeft:"10px"}}>Delete</Button>
                
            </>
          ),
          
        },
      ];
      
      const data = dataGame
     console.log(dataGame)

     const [search, setSearch] = useState("")
    const [filter, setFilter] = useState({
      genre: "",
      release: 0,
      platform:""
    })

const handleChange = (e) => {
 
  let value = e.target.value
 
 setSearch(value)
}

const handleChangeFilter = (e) => {
  let value = e.target.value
  let typeOfName = e.target.name

  setFilter({...filter, [typeOfName] : value})
}

const handleSearch = async (e) => {
e.preventDefault()

let result = await axios.get('https://backendexample.sanbersy.com/api/data-game')

let dataSearch = result.data

let resultSearch = dataSearch.filter((e) => {
  return (
    Object.values(e).join(" ").toLowerCase().includes(search.toLowerCase())
  )

}

)
setSearch("")
setDataGame([...resultSearch])
}

const handleFilter = async (e) => {
  e.preventDefault()

let result = await axios.get('https://backendexample.sanbersy.com/api/data-game')

let dataSearch = result.data

let resultFilter = dataSearch.filter((e) => {
return e.genre.toLowerCase() === filter.genre.toLowerCase() || e.release === filter.release || e.platform.toLowerCase() === filter.platform.toLowerCase()
})

setFilter ({
      genre: "",
      release: 0,
      platform:""
})
setDataGame([...resultFilter])

}
      
return (
    <>
    <div>
    <h1  style={{color: "white", fontSize: "35px", marginTop:"10px", textAlign:"center", fontWeight:"bold", marginTop: "80px"}}>Data Games</h1>
   
    <form style={{display:"flex", flexDirection:"row"}} onSubmit={handleFilter}>
     <Input name="genre" onChange={handleChangeFilter} style={{marginRight: "20px", width: "280%"}} type="text" placeholder="Genre"/>
     <Input name="release" onChange={handleChangeFilter} style={{marginRight: "20px", width: "280%"}} type="text" placeholder="Release" />
     <Input name="platform" onChange={handleChangeFilter} style={{width: "280%", marginRight: "10px"}} type="text"placeholder="Platform" />
     <Input style={{width: "100%", height:"50%", fontSize: "10px"}} type="submit" value="Filter"/>
    </form>

   <form style={{display:"flex", flexDirection:"row", marginTop: "-20px"}} onSubmit={handleSearch} >
     <Input onChange={handleChange} value={search} style={{width: "300%"}} type="text" placeholder="Search Games's Name..." />
     <Input style={{width: "100%", height:"50%", fontSize: "10px"}}type="submit" value="Search"/>
    
    </form>
   <Button type="primary" onClick ={()=>{
     setFetchStatus(true)
   }}>Reset Filter</Button>
   <h1> 
     <br/>
<Table className="table-tugas15" columns={columns} dataSource={data} scroll={{ x: 750, y: 3000 }}  />
</h1>
</div>
</>


    )}

export default DataGames